import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { AuthProvider } from './lib/AuthContext';
import App from './App';
import './index.css';
// Light theme LAST: it is an override layer scoped to `html.light`, and source
// order has to agree with specificity (DDIR theme spec v1 §8.2). Deleting this
// import and the file restores the dark-only app exactly.
import './light-theme.css';
import './workspace.css';
import './kit.css';

// F4#3: Sentry frontend SDK. Opt-in via VITE_SENTRY_DSN injected at
// build time. When the var is empty (local dev, preview builds) the
// SDK stays silent — no events transmitted.
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'unknown',
    release: import.meta.env.VITE_APP_VERSION || 'unknown',
    // Sample 5% of transactions for performance monitoring. Matches
    // the backend traces_sample_rate so the two correlate.
    tracesSampleRate: 0.05,
    // Drop form-field values from breadcrumbs — they may contain
    // driver names or other PII the operator is typing into the UI.
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.category === 'ui.input') return null;
      return breadcrumb;
    },
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h2>Something went wrong.</h2>
          <p>The error has been reported. Try reloading the page.</p>
        </div>
      }
    >
      <AuthProvider>
        <App />
      </AuthProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
